import React from "react";
import { Table, Skeleton } from "antd";
import type { ColumnsType } from "antd/es/table";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { ApprovalStatus } from "../../../../../components";
import { Button } from "antd";
import { FontFa } from "../../../../../components";
import { useHistory } from "react-router-dom";
import { PATH } from "../constant/path";
import { useGetMyRequests } from "../hooks/get-my-requests";

const columns: ColumnsType<any> = [
  {
    title: "Mã yêu cầu",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Ngày tạo",
    dataIndex: "createdDateTime",
    key: "createdDateTime",
    render(value, record, index) {
      return getDDMMYYYFormat(record?.createdDateTime);
    },
  },
  {
    title: "Người tạo",
    dataIndex: "createdBy",
    key: "createdBy",
    render(value, record, index) {
      return record?.createdBy?.user?.displayName;
    },
  },
  {
    title: "Yêu cầu",
    dataIndex: "type",
    key: "type",
    render(value, record, index) {
      return <span className="flag warning">Yêu cầu</span>;
    },
  },
  {
    title: "Cơ quan/đơn vị",
    dataIndex: "eDepartment",
    key: "eDepartment",
    render(value, record, index) {
      return record?.fields?.eDepartment;
    },
  },
  {
    title: "Trạng thái",
    dataIndex: "eRequestStatus",
    key: "eRequestStatus",
    render(value, record, index) {
      return <ApprovalStatus status={record?.fields?.eRequestStatus} />;
    },
  },
  {
    title: "Xuất tài liệu",
    dataIndex: "Download",
    key: "Download",
    render(value, record, index) {
      return (
        <Button
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      );
    },
  },
];

export const MyRequests: React.FC = () => {
  const history = useHistory();

  const { data, isLoading } = useGetMyRequests();

  if (isLoading) return <Skeleton />;

  return (
    <Table
      rowClassName="cursor-pointer"
      columns={columns}
      dataSource={data}
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            history.push(PATH.DETAIL.replace(":id", record.id));
          },
        };
      }}
    />
  );
};
